import { InjectionToken } from '@angular/core';

export const SERVICE_WORKER_GET_REGISTRATION_BY_SCOPE = new InjectionToken<boolean>('SERVICE_WORKER_GET_REGISTRATION_BY_SCOPE');
